/**
 * navigation/useActiveView.ts
 * Current top-level section for the sidebar's active-item highlight, read from
 * the container ref (the sidebar lives outside the navigator). Detail / run
 * routes roll up to their parent section (jobDetail & run → jobs,
 * candidateDetail → candidates).
 */

import { useEffect, useState } from 'react';
import { navigationRef } from './navigationRef';
import type { AppRouteName, NavSection } from './types';

const PARENT: Partial<Record<AppRouteName, NavSection>> = {
  jobDetail: 'jobs',
  run: 'jobs',
  candidateDetail: 'candidates',
};

export function useActiveView(): NavSection {
  const [active, setActive] = useState<NavSection>('dashboard');

  useEffect(() => {
    const sync = () => {
      const current = navigationRef.isReady() ? navigationRef.getCurrentRoute() : undefined;
      if (!current) return;
      const name = current.name as AppRouteName;
      setActive(PARENT[name] ?? (name as NavSection));
    };
    sync();
    const unsubscribe = navigationRef.addListener('state', sync);
    return unsubscribe;
  }, []);

  return active;
}
